
var sprite = require("D:/a/1/s/Web/CMS/App_Themes/Safestore/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 52.022 52.022\" id=\"icon-house\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <path d=\"M26.011,0C11.646,0,0,11.646,0,26.01c0,14.365,11.646,26.012,26.011,26.012\r\n\tc14.364,0,26.012-11.646,26.012-26.012C52.022,11.646,40.375,0,26.011,0 M38.289,24.928h-3.31v12.22\r\n\tc0,0.316-0.257,0.571-0.572,0.571h-5.216v-8.176c0-0.316-0.257-0.572-0.571-0.572h-5.217c-0.316,0-0.572,0.256-0.572,0.572v8.176\r\n\th-5.217c-0.315,0-0.571-0.255-0.571-0.571v-12.22h-3.31c-0.224-0.223-0.224-0.585,0-0.809l11.874-11.874\r\n\tc0.223-0.223,0.585-0.223,0.808,0L38.289,24.12C38.513,24.343,38.513,24.706,38.289,24.928\"/> </symbol>";
module.exports = sprite.add(image, "icon-house");


/*****************
 ** WEBPACK FOOTER
 ** ./svg/src/house.svg
 ** module id = 189
 ** module chunks = 24
 **/